import React from "react";
import { useLocation } from "react-router-dom";

// 500 view. Hardcoded English on purpose: if the crash is in the i18n layer, calling
// t() here would crash the error page too. No translation, no fallback that can fail.
const Error500 = () => (
  <main
    data-testid="error-500"
    className="min-h-screen flex flex-col items-center justify-center text-center px-6"
    style={{ background: "var(--bg-primary)" }}
  >
    <h1 className="text-3xl sm:text-4xl font-bold mb-3" style={{ color: "var(--text-primary)" }}>
      Something broke on our end.
    </h1>
    <p className="text-base mb-8" style={{ color: "var(--text-secondary)" }}>
      We're on it. Try again in a moment.
    </p>
    <div className="flex flex-wrap gap-3 justify-center">
      <button
        data-testid="error-500-refresh"
        onClick={() => window.location.reload()}
        className="px-6 py-3 rounded-full text-sm font-semibold"
        style={{ background: "var(--accent-primary)", color: "#fff" }}
      >
        Refresh
      </button>
      <a
        data-testid="error-500-home"
        href="/"
        className="px-6 py-3 rounded-full text-sm font-medium"
        style={{ border: "1px solid var(--border-color)", color: "var(--text-primary)" }}
      >
        Back to Home
      </a>
    </div>
  </main>
);

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Log for diagnostics; never rethrow.
    console.error("Render crash caught by ErrorBoundary:", error, info);
  }

  componentDidUpdate(prev) {
    // Reset on navigation so a caught error does not follow the person around the site.
    if (prev.resetKey !== this.props.resetKey && this.state.hasError) {
      this.setState({ hasError: false });
    }
  }

  render() {
    if (this.state.hasError) return <Error500 />;
    return this.props.children;
  }
}

export const ErrorBoundary = ({ children }) => {
  const location = useLocation();
  return <ErrorBoundaryInner resetKey={location.pathname}>{children}</ErrorBoundaryInner>;
};
